import { gql, TypedDocumentNode } from "@apollo/client";

import {
  EditObjectiveNormalDefaultsMutation,
  EditObjectiveNormalDefaultsMutationVariables,
} from "./ObjectiveNormalDefaults.generated";

export const EDIT_OBJECTIVE_NORMAL_DEFAULTS: TypedDocumentNode<
  EditObjectiveNormalDefaultsMutation,
  EditObjectiveNormalDefaultsMutationVariables
> = gql`
  mutation editObjectiveNormalDefaults(
    $objectiveNormalDefaultsInput: ObjectiveNormalDefaultsInput!
  ) {
    editObjectiveNormalDefaults(
      objectiveNormalDefaultsInput: $objectiveNormalDefaultsInput
    ) {
      ok
    }
  }
`;
